import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Box, Container, Grid, Typography, Link, useTheme, useMediaQuery } from '@mui/material';

const Overview = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // openInNewTab removed (unused)

    const socialIconStyle = {
        mx: 1,
        fontSize: '2rem',
        '&:hover': {
            transform: 'scale(1.1)',
            transition: 'transform 0.2s ease-in-out',
        },
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <NavBar />
            <Box
                sx={{
                    mt: 6,
                    backgroundImage: 'url("/assets/img/about/Overview1.jpg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant={isMobile ? 'h3' : 'h2'}
                    component="h2"
                    sx={{
                        color: '#ffffff',
                        textShadow: '2px 2px 8px #000000',
                        fontWeight: 'bold',
                        fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                    }}
                >
                    ABOUT BEADS
                </Typography>
            </Box>

            <Container sx={{ py: 5, m: 'auto' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ mt: { xs: 5, md: 0 } }}>

                            <Typography variant="h5" sx={{ color: 'black', fontWeight: 'bold', mb: 2 }}>
                                BEADS FOR EDUCATION WAS FOUNDED IN 1993 BY DEBBY ROONEY AND LISA STEVENS.
                            </Typography>

                            <Typography paragraph>
                                In the beginning, the focus was on selling the beadwork of the Dupoto Women's Group in the USA so they could send their daughters to school. Many years later, BEADS Sponsors pay the school fees of over 300 girls at three different schools in Kenya.
                            </Typography>
                            <Typography variant="h5" sx={{ my: 2 }}>
                                BEADS FOR EDUCATION, INC IS A 501(C)(3) TAX-EXEMPT ORGANIZATION.
                            </Typography>
                            <Typography paragraph>
                                BEADS for Education is headquartered in Brookfield, CT, USA and operates programs exclusively in Kenya. Any material generated outside Brookfield or the authorized programs in Kenya is not related to BEADS for Education, INC.
                            </Typography>
                        </Box>

                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box sx={{ mt: { xs: 5, md: 0 }, mb: 5, textAlign: 'center' }}>

                            <img src='assets/img/about/classroom.png' alt='classroom' style={{ maxWidth: '75%', borderRadius: '1rem' }} />

                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                <Link href='https://www.facebook.com/beadsforeducation/' target='_blank' sx={{ ...socialIconStyle, color: '#3b5998' }}>
                                    <FaFacebookF />
                                </Link>
                                <Link href='https://twitter.com/Beads4Education' target='_blank' sx={{ ...socialIconStyle, color: '#1da1f2' }}>
                                    <FaTwitter />
                                </Link>
                                <Link href='https://www.instagram.com/beadsforeducation/' target='_blank' sx={{ ...socialIconStyle, color: '#e1306c' }}>
                                    <FaInstagram />
                                </Link>
                                <Link href='https://www.youtube.com/beads-for-education-inc' target='_blank' sx={{ ...socialIconStyle, color: '#ff0000' }}>
                                    <FaYoutube />
                                </Link>
                            </Box>
                        </Box>
                    </Grid>

                </Grid>

                <Grid container spacing={3} sx={{ my: 5 }}>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src='assets/img/icon/icon-1.png' alt='img' className='icon-image' style={{ width: 'auto', height: 'auto', objectFit: 'contain' }} />
                            <Typography variant="h5">Our Vision</Typography>
                            <Typography>
                                To educate and empower marginalized girls from the Maasai community. We have been sponsoring girls’ tuition for education since 1998.
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src='assets/img/icon/icon-2.png' alt='img' className='icon-image' style={{ width: 'auto', height: 'auto', objectFit: 'contain' }} />
                            <Typography variant="h5">Our MISSION</Typography>
                            <Typography>
                                To empower girls from vulnerable Maasai communities through giving them access to quality education characterized by critical thinking and leadership skills which prepare them to become independent and successful women with dignified jobs, healthy families and of great impact in their communities.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                <Container maxWidth="md" sx={{ mt: 10 }}>
                    <Box textAlign="center">
                        <Typography variant="h4">A DREAM</Typography>
                        <Typography variant="h5" gutterBottom sx={{ color: 'black', mt: 2 }}>BY BERYL AWOUR</Typography>
                        <Typography sx={{ fontStyle: 'italic', mb: 2 }}>7th grade • 13-year-old girl • Top Ride School • Isinya, Kenya</Typography>
                    </Box>
                    <Grid container spacing={2} justifyContent="center">
                        {/* First Column */}
                        <Grid item xs={12} sm={6}>
                            <Typography paragraph sx={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
                                I have a dream<br />
                                That one day all the little girls<br />
                                And little boys in this country<br />
                                Will be great women and great men<br />
                                Governing this country in a spirit of love.<br /><br />

                                I have a dream<br />
                                That my little boy will not despise my little girl<br />
                                Because she is a girl<br />
                                And that my little girl will not hate my little boy<br />
                                Because their daddy left him all our wealth<br />
                                Because he is a male.
                            </Typography>
                        </Grid>
                        {/* Second Column */}
                        <Grid item xs={12} sm={6}>
                            <Typography paragraph sx={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
                                I have a dream<br />
                                That a day will come when my little girl<br />
                                Will be judged by her brains<br />
                                And by her contribution to the whole world,<br />
                                Not by the shape of her hips<br />
                                Not by the number of her offspring.<br /><br />

                                Yes, I have a dream that one day our children will say<br />
                                It is not for nothing that Martin Luther King died<br />
                                Not for nothing that Mandela is going blind<br />
                                Not for nothing the long debates on the equality of women.<br />
                                My little children, please make my dream come true.
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>

                <Container sx={{ textAlign: 'center', my: 5 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Video : <Link href="https://www.youtube.com/watch?v=o4Mbh1y1mBA" target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'none' }}>
                            A Visit to the BEADS for Education High School
                        </Link>
                    </Typography>
                    <Box sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        width: '100%',
                        maxWidth: '640px', // This sets the maximum width of the video
                        height: '360px', // This sets the height of the video
                        margin: 'auto' // This centers the video horizontally
                    }}>
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/o4Mbh1y1mBA"
                            title="Beads for Education"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ borderRadius: '1rem' }}
                        ></iframe>
                    </Box>
                </Container>
            </Container>
            <FooterOne />
        </Box>
    );
};

export default Overview;
